import { render, staticRenderFns } from "./modalAddDownload.vue?vue&type=template&id=87ddec0a&scoped=true&"
import script from "./modalAddDownload.vue?vue&type=script&lang=js&"
export * from "./modalAddDownload.vue?vue&type=script&lang=js&"
import style0 from "./modalAddDownload.vue?vue&type=style&index=0&id=87ddec0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ddec0a",
  null
  
)

export default component.exports